import { Component, Inject } from '@angular/core';
import { Router }    from '@angular/router';
import { AuthService } from '../core/services/auth.service';
import { environment } from '../../environments/environment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  username = '';
  password = '';
  errorMessage = '';
  env = environment;

  constructor(
    private authService: AuthService,
    private router: Router,
    private oidc: OidcSecurityService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  onSubmit(): void {
    if (this.authService.login(this.username, this.password)) {
      // La redirección ahora se maneja automáticamente en AuthService
    } else {
      this.errorMessage = 'Usuario o contraseña incorrectos';
    }
  }

  onOidcLogin(): void {
    console.log('🔴 lanzando OIDC authorize()');
    if (!isPlatformBrowser(this.platformId)) return;
    console.log('🔴 authorize()');
    this.oidc.authorize();
    // this.authService.login();
  }

  onForceLogout(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    try { this.oidc.logoffLocal(); } catch {}
    try { sessionStorage.clear(); } catch {}
    try { localStorage.removeItem('currentUser'); } catch {}

    const domain = environment.oidc.cognitoDomain;
    const url =
      `https://${domain}/logout` +
      `?client_id=${encodeURIComponent(environment.oidc.clientId)}` +
      `&logout_uri=${encodeURIComponent(environment.oidc.postLogoutRedirectUri)}`;

    window.location.href = url;
  }
}
